__turbopack_context__.v({
  "container": "style-module-scss-module__dFwDlG__container",
  "label": "style-module-scss-module__dFwDlG__label",
});
